"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineMemberPermissionRegister = exports.MemberPermissionRegister = void 0;
const apis_1 = require("./apis");
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const lib_es2015_2 = require("@hodol/complex-inputs/lib-es2015");
const lib_es2015_3 = require("@hodol/dom-helper/lib-es2015");
const Constants = require("./constants");
const apis_2 = require("../oauth-client/apis");
const OauthClient = require("../oauth-client/entity");
const apis_3 = require("../member-group/apis");
class MemberPermissionRegister extends HTMLElement {
    constructor() {
        super();
        this.apis = new apis_1.default();
        this.router = (0, lib_es2015_1.useRouter)();
        this.oauthClientApis = new apis_2.default();
        this.memberGroupApis = new apis_3.default();
        this.style.setProperty('display', 'block');
    }
    connectedCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            this.innerHTML = `
    <div class="register-form">
      <div class="register-form-field-name">Oauth Client Id</div>
      <div><search-selector class="oauth-client-pk"></search-selector></div>
      
      <div class="register-form-field-name">Member Group</div>
      <div><search-selector class="member-group-pk"></search-selector></div>
      
      <div class="register-form-field-name">Kind</div>
      <div><input class="kind" /></div>
      
      <div class="register-form-field-name">Resource</div>
      <div><input class="resource" /></div>
      
      <div class="register-form-field-name">Is Allowed</div>
      <div>
        <select class="is-allowed">
          <option value="true">allowed</option>
          <option value="false">denied</option>
        </select>
      </div>
      
      <div class="register-form-footer"><button class="submit-btn">Submit</button></div>
    </div>`;
            this.oauthClientPKSelector = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'search-selector.oauth-client-pk');
            this.oauthClientPKSelector.init({ value: '', displayText: '', description: '' }, this.oauthClientApis.listForSearchSelector);
            this.memberGroupPKSearchSelector = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'search-selector.member-group-pk');
            this.memberGroupPKSearchSelector.init({ value: '', displayText: '', description: '' }, (query) => __awaiter(this, void 0, void 0, function* () {
                if (this.oauthClientPKSelector.value === '') {
                    alert(`select oauth client first!`);
                    return [];
                }
                return yield this.memberGroupApis.getListApiForMemberGroupSearchSelectorByOauthClientPK(this.oauthClientPKSelector.value)(query);
            }));
            this.kindInput = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'input.kind');
            this.resourceInput = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'input.resource');
            this.isAllowedSelect = (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'select.is-allowed');
            this.isAllowedSelect.value = 'false';
            (0, lib_es2015_3.getQuerySelectOrThrowError)(this, 'button.submit-btn').addEventListener('click', () => {
                if (this.kindInput.value === '') {
                    alert(`put ${Constants.subjectName} kind`);
                    return;
                }
                if (this.oauthClientPKSelector.value === '') {
                    alert(`put ${Constants.subjectName}'s Oauth Client pk.`);
                    return;
                }
                void (() => __awaiter(this, void 0, void 0, function* () {
                    const insertedPKOrNull = yield this.apis.insert({
                        pk: 0,
                        oauth_client_pk: Number(this.oauthClientPKSelector.value),
                        member_group_pk: Number(this.memberGroupPKSearchSelector.value),
                        kind: this.kindInput.value,
                        resource: this.resourceInput.value,
                        is_allowed: this.isAllowedSelect.value === 'true',
                        oauth_client: OauthClient.newEntity(),
                        member_group_name: '',
                    });
                    if (insertedPKOrNull === null) {
                        return;
                    }
                    alert('Create Member Permission Successfully!');
                    this.router.push(`/web/${Constants.routerPathGroup}/list?page_no=1&page_size=10&query=&oauth_client_pk=`);
                }))();
            });
        });
    }
}
exports.MemberPermissionRegister = MemberPermissionRegister;
const defineMemberPermissionRegister = (name) => {
    (0, lib_es2015_2.defineSearchSelector)('search-selector');
    (0, lib_es2015_1.defineIfUndefined)(name, MemberPermissionRegister);
};
exports.defineMemberPermissionRegister = defineMemberPermissionRegister;
